import { type ExtraValues, type PlatformEvent } from '../types';

export const pdAdBannerShownEvent = (extra?: ExtraValues): PlatformEvent => {
  return {
    type: 'show',
    user_properties: {},
    event_properties: {
      name: 'ad',
      ...(extra && { ...extra.event_properties }),
    },
  };
};
